import React, {Component} from 'react';
import {Switch, Route, withRouter} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../../SYSTEM/Config.js'
import { sendPostRequest } from "./../../../APP/HELPERS/requests"

/// REDUX ///
import * as ReduxActions from './../../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

function mapStateToProps(state) {
    return {
        PRODUCTS: state.PRODUCTS,
        SHOW_SEARCH: state.SHOW_SEARCH
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class MobileSearchBlock extends Component {

	constructor(props)
    {
        super(props);
        this.state = {
            SUGGESTIONS: false,
            RESULTS: false,
            STRING: ''
        }

        this.setHistoryRef = this.setHistoryRef.bind(this);
        this.setInputRef = this.setInputRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.SHOW_SEARCH !== prevProps.SHOW_SEARCH) {
            if (!this.props.SHOW_SEARCH) {
                this.stopSearch();
            } else {
                this.input.focus();
            }
        }
    }

    setHistoryRef(node) {
        this.history = node;
    }

    setInputRef(node) {
        this.input = node;
    }

    handleClickOutside(event) {
        if (this.history && !this.history.contains(event.target)) {
            if (this.state.SUGGESTIONS) {
                this.setState({SUGGESTIONS: false});
            }
        }
    }

    somethingInputted = (string) =>
    {
        let STRING = string.target.value;
        this.setState({STRING: STRING});

        if (STRING.length > 2) {
            this.filterProducts(STRING);
        } else {
            this.setState({SUGGESTIONS: false, RESULTS: false})
        }
    }

    filterProducts = async (text) => 
    {
        if (this.props.PRODUCTS) {
            try {
                let SEND_DATA = {
                    action:     'searchString',
                    string:     text
                };

                let data = await sendPostRequest(SEND_DATA,CONFIG.API_GATE);
                if (data !== false) {
                    if (data.results.length) {
                        this.setSearchResults(data.results, text);
                    } else {
                        this.setState({RESULTS: [], SUGGESTIONS: false, STRING: text});
                    }
                } else {
                    this.setState({RESULTS: [], SUGGESTIONS: false, STRING: text});
                }
            } catch (error) {
                this.setState({RESULTS: [], SUGGESTIONS: false, STRING: text});
            }
            
        }
    }

    setSearchResults(IDS, text)
    {
        let PRODUCTS = this.props.PRODUCTS;
        let FOUND = [];
        let COMPONENT = this;

        let MAX = 8;
        for (let i =0; i < IDS.length; i++) {
            let ID = IDS[i];
            if (typeof PRODUCTS[ID] !== "undefined") {
                let PRODUCT = PRODUCTS[ID];
                if (FOUND.length <= MAX) {
                    FOUND.push(
                        <span key={PRODUCT.id} className="search-result-row" onClick={() => this.props.openProductModal(PRODUCT.id)}>
                            {PRODUCT.title}
                        </span>
                    );
                }
            }
        }


        this.setState({RESULTS: FOUND, SUGGESTIONS: true, STRING: text});
    }

    onFocus = () =>
    {
        this.setState({SUGGESTIONS: true});
    }

    onFocusOut = () =>
    {
        this.setState({SUGGESTIONS: false});
    }

    renderResults()
    {
        if (this.state.SUGGESTIONS) {
            if (this.state.RESULTS) {
                return (
                    <div className="search" ref={this.setHistoryRef}>
                        {this.state.RESULTS}
                    </div>
                );
            }
        }
    }

    renderReset()
    {
        if (this.state.STRING.length > 0) {
            return (
                <a className="search-controls-btn" onClick={() =>this.stopSearch()} ><i className="fas fa-times"></i></a>
            );
        }
    }

    stopSearch()
    {
        this.setState({RESULTS: false, SUGGESTIONS: false, STRING: ''});
        if (this.props.SHOW_SEARCH) {
            this.input.focus();
        }
    }

    handleSearch = (e) => {
        if (e.key === 'Enter') {
            this.startSearch()
        }
    }

    startSearch()
    {
        this.setState({SUGGESTIONS: false, RESULTS: false})
        this.props.doSearch(this.state.STRING);
        ///document.location.href = '/search/' + this.state.STRING;
    }

	render() {
        if (!this.props.SHOW_SEARCH) {
            return false;
        }
		return (
			<div className="searching">
                <input 
                    onKeyDown={this.handleSearch}
                    className="searchinput"
                    type="text"
                    placeholder="Поиск"
                    onChange={(text) => this.somethingInputted(text)}
                    value={this.state.STRING}
                    ref={this.setInputRef}
                />
                <a className="search-btn" onClick={() => this.startSearch()}><i className="fas fa-search"></i></a>
                {this.renderReset()}
                {this.renderResults()}
            </div>
		);
	}

}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MobileSearchBlock)
